'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key]}}}return target};

const _=require('pulsar-utils/dist-es6/_');
const io=require('socket.io-client');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const AppReloadRequiredError=require('../../../dist-es6/client/services/errors/appReloadRequiredError');
const SessionExpiredError=require('../../../dist-es6/client/services/errors/sessionExpiredError');
const waitUntil=require('../../../dist-es6/testUtils/waitUntil');
const CustomError=require('pulsar-utils/dist-es6/customError');
const AccessDeniedError=require('../../../dist-es6/client/services/errors/accessDeniedError');
const customParser=require('socket.io-msgpack-parser');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const pRetry=require('p-retry');

const CompleteReconnectionThrottleTimeMs=5000;
const isBrowser=typeof window=='object';
const DefaultClientOptions={
path:'/socket.io',
transports:['websocket'],
parser:customParser,
reconnection:isBrowser,
reconnectionDelay:isBrowser?500:0};let


SocketService=class SocketService extends BaseService{
constructor($location,$rootScope,cookieRefresherService,Analytics,appVersionService,progressService){
super();
this._$location=$location;
this._$rootScope=$rootScope;
this._cookieRefresherService=cookieRefresherService;
cookieRefresherService.socketService=this;
this._analytics=Analytics;
this._appVersionService=appVersionService;
this._progressService=progressService;

this._throttledReconnect=_.throttle(()=>this.reconnect(),CompleteReconnectionThrottleTimeMs);

this._socketOptions=DefaultClientOptions;

if("production"==='test'){
this._socketOptions.ca=require('pulsar-certs/getEnvCa')('test');
}

this.useMockConnectionStatus=!1;
this.mockConnectionStatus=!0;

this._connected=!1;
this._initiallyConnected=!1;
this.reconnect();
}

reconnect(){
if(_.exists(this._socket)){
this._socket.removeAllListeners();
this._socket.destroy();
delete this._socket;
}

this._resolvesAndRejects={};
this._socket=io.connect(`${this._$location.protocol()}://${this._$location.host()}:${this._$location.port()}`,this._socketOptions);

this._socket.on('error',error=>{
if("production"!=='production'){
console.error(error);
}
this._analytics.trackEvent('socket','error',`${error.stack||error.description||error.message||error}`.replace(/[\r\n\t]+/g,' | '));
});

return new Promise((resolve,reject)=>{
this._socket.on('connect',()=>{
this._initiallyConnected=!0;
this._$rootScope.$evalAsync(()=>{
this._connected=!0;
resolve();
});
});

this._socket.on('progress',req=>this._$rootScope.$evalAsync(()=>this._progressService.updateCurrentProgress(req)));

this._socket.on('disconnect',()=>{
resolve(this.reconnect());
this._$rootScope.$evalAsync(()=>this._connected=!1);
});
});
}

get isConnected(){
return this.useMockConnectionStatus?
this.mockConnectionStatus:
_.get(this._socket,'connected',this._connected);
}

_getResolvesAndRejectsFor(messageName,throwOnUnexpectedError){
if(!_.exists(this._resolvesAndRejects[messageName])){
let messageSpecificResolvesAndRejects={};
this._socket.on(`${messageName} - response`,responsePacket=>{
if(!_.exists(messageSpecificResolvesAndRejects[responsePacket.id])){
throw new Error(`no resolve/reject found for ${messageName}: ${responsePacket.id}`);
}

let{resolve,reject,startTime,isTimedOut,timeoutId}=messageSpecificResolvesAndRejects[responsePacket.id];

delete messageSpecificResolvesAndRejects[responsePacket.id];

if(isTimedOut===!0){
return;
}

if(_.exists(timeoutId)){
clearTimeout(timeoutId);
}

switch(responsePacket.data.status){
case'AppReloadRequired':
reject(new AppReloadRequiredError);
break;
case'NotLoggedIn':
reject(new SessionExpiredError);
break;
case'AccessDenied':
reject(new AccessDeniedError);
break;
case'UnexpectedError':
case'InternalError':
if(throwOnUnexpectedError){
reject(new UnexpectedError);
}else{
resolve(responsePacket.data);
}
break;
default:
this._analytics.trackTimings('socket',messageName,Date.now()-startTime);
resolve(responsePacket.data);
break;}

});

this._resolvesAndRejects[messageName]=messageSpecificResolvesAndRejects;
}

return this._resolvesAndRejects[messageName];
}

async sendAndWaitForResponse(messageName,requestData={},options={}){
const{timeoutInSeconds=void 0,retryOptions=void 0,throwOnUnexpectedError=!1,keepSessionAlive=!0}=options;

_.ensureInstanceOf('string',messageName);
_.ensureInstanceOf(['number','nullable'],timeoutInSeconds);
_.ensureInstanceOf(['object','nullable'],retryOptions);
_.ensureInstanceOf('boolean',throwOnUnexpectedError);
if(retryOptions){
return await this._retriedSendAndWaitForResponse(messageName,requestData,options);
}
await waitUntil(()=>{
if(!this._initiallyConnected){
return!0;
}

const isConnected=_.exists(this._socket)&&this._socket.connected===!0;

if(isConnected){
return!0;
}

this._throttledReconnect();
return isConnected;
},100);

const messageSpecificResolvesAndRejects=this._getResolvesAndRejectsFor(messageName,throwOnUnexpectedError);

const request={
id:Guid.create().toString(),
data:requestData,
keepSessionAlive,
appRevision:this._appVersionService.getRevision()};


return await new Promise((resolve,reject)=>{
messageSpecificResolvesAndRejects[request.id]={resolve,reject,startTime:Date.now()};

if(_.exists(timeoutInSeconds)){
messageSpecificResolvesAndRejects[request.id].timeoutId=setTimeout(()=>{
if(_.exists(messageSpecificResolvesAndRejects[request.id])){
reject(new SocketTimeoutError);
messageSpecificResolvesAndRejects[request.id].isTimedOut=!0;
}
},timeoutInSeconds*1000);
}

this._$rootScope.$evalAsync(()=>this._progressService.updateCurrentProgress({[messageName]:0.01}));
this._socket.emit(`${messageName} - request`,request);
if(keepSessionAlive){
this._cookieRefresherService.refreshCookie();
}
this._analytics.trackEvent('socket','emit',messageName);
});
}

async _retriedSendAndWaitForResponse(messageName,requestData,options){
_.ensureInstanceOf('string',messageName);
const{retryOptions,throwOnUnexpectedError}=options;
let attempt=0;
try{
return await pRetry(async()=>{
try{
attempt++;
return await this.sendAndWaitForResponse(messageName,_extends({attempt},requestData),_extends({
throwOnUnexpectedError:!0},
_.omit(options,['retryOptions','throwOnUnexpectedError'])));

}catch(e){
if(e instanceof SocketTimeoutError||e instanceof UnexpectedError){
throw e;
}else{
throw new pRetry.AbortError(e);
}
}
},
retryOptions);
}catch(e){
if(e instanceof UnexpectedError){
if(throwOnUnexpectedError){
throw e;
}
return new SocketResponse('UnexpectedError');
}
throw e;
}
}

dispose(){
return new Promise(resolve=>{
this._socket.on('disconnect',()=>{
this._socket.removeAllListeners();
resolve();
});
this._socket.disconnect();
});
}};let


SocketTimeoutError=class SocketTimeoutError extends CustomError{
constructor(){
super('SocketTimeoutError');
}};let


UnexpectedError=class UnexpectedError extends CustomError{
constructor(){
super('UnexpectedError');
}};


module.exports=SocketService;
module.exports.SocketTimeoutError=SocketTimeoutError;
module.exports.UnexpectedError=UnexpectedError;
//# sourceMappingURL=socketService.js.map
